import Page from '../Page';
import Connection from '../../components/Connection/Connection';
import ConnectionSocial from '../../components/ConnectionSocial/ConnectionSocial';

export default class Authentication extends Page {
  private guestSubmit: HTMLButtonElement;

  private guestLoginEmailValid = false;

  private guestLoginOrderIdValid = false;

  constructor() {
    super();
    this.guestSubmit = document.querySelector('.js-guestSubmit');

    this.inputsGuestForm();
    new Connection();
    new ConnectionSocial();
  }

  inputsGuestForm() {
    const guestLoginEmail: HTMLInputElement =
      document.querySelector('#guest_login_email');
    const guestLoginOrderId: HTMLInputElement = document.querySelector(
      '#guest_login_orderId'
    );

    this.toggleButtonGuestForm();

    guestLoginEmail.addEventListener('input', () => {
      this.guestLoginEmailValid = guestLoginEmail.value.length > 0;

      this.toggleButtonGuestForm();
    });

    guestLoginOrderId.addEventListener('input', () => {
      this.guestLoginOrderIdValid = guestLoginOrderId.value.length > 0;

      this.toggleButtonGuestForm();
    });
  }

  toggleButtonGuestForm() {
    if (this.guestSubmit) {
      this.guestSubmit.disabled = !(
        this.guestLoginEmailValid && this.guestLoginOrderIdValid
      );
    }
  }
}

new Authentication();
